import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import IdolInline from '@/components/ui/IdolInline';
import SuspendedMark from '@/components/ui/SuspendedMark';

/**
 * Navbar 切換偶像選單中的停權偶像列：disabled、灰階，頭像右下角疊 ban 標記，不可點選。
 *
 * 版面與 AppNavbar 的 IdolItemNode 相同（IdolInline），但不修改 IdolInline／IdolItemNode
 * （與 feature/fan-analytics 的衝突守則，見 docs/suspension-plan.md §2），
 * 因此 ban 標記用一個與頭像同尺寸（img-sm）的定位框疊在 IdolInline 的頭像位置上。
 *
 * @param {Object} idol - /idol/get-idol-array 的一筆偶像資料
 */
function SuspendedIdolItem({ idol }) {
  return (
    <Dropdown.Item
      as="button"
      disabled
      // text-body：蓋掉 disabled 的淡色，名稱只由 .idol-suspended 淡化一次，與 IdolPickList 一致
      className="d-flex align-items-center border-top py-2 text-body"
    >
      <div className="position-relative min-w-0">
        <IdolInline idol={idol} className="idol-suspended" />
        {/* IdolInline 的頭像在最左側且決定整列高度，同尺寸的框即對齊頭像 */}
        <div className="position-absolute top-0 start-0 img-sm">
          <SuspendedMark variant="icon" />
        </div>
      </div>
    </Dropdown.Item>
  );
}

SuspendedIdolItem.propTypes = {
  idol: PropTypes.shape({
    idol_nick_name: PropTypes.string,
    idol_avatar_url: PropTypes.string,
    idol_is_official: PropTypes.bool.isRequired,
  }).isRequired,
};

export default SuspendedIdolItem;
